// extracted by mini-css-extract-plugin
export default {"banner":"PromoBanner_banner__7bUE3","highlight":"PromoBanner_highlight__ggs9c","bold":"PromoBanner_bold__Hd7Wv","logo":"PromoBanner_logo__04u7f"};